import * as React from 'react';
import { observer } from 'mobx-react';

import { SubmitMessage, SubmitMessageIcon, TicketAndCouponMessage, TicketButton } from 'common--design-library';

import { translation } from 'easit--localization';


export interface IAcceptOrRejectProps {
    clearCoupon: () => void;
    prepareJustSentCouponCopy: () => void;
    isAccepted: boolean;
    allowTicketCopy: boolean;
    isTicketCopyInProgress: boolean;
    errors?: string[];
    hideButtons?: boolean;
    removeMargins?: boolean;
    canSwapPrimarySecondary: boolean;
}

export const AcceptOrReject: React.FC<IAcceptOrRejectProps> = observer((props: IAcceptOrRejectProps) => { //TODO do we need observer here?
    return (
        <div>
            <div>
                {
                    props.isAccepted
                        ? <SubmitMessage roleForTest="ticket__submit-success" removeMargins={props.removeMargins}>
                            <SubmitMessageIcon className="fa fa-check accepted" />
                            {translation().coupon_SentSuccessMessage}
                        </SubmitMessage>
                        : <SubmitMessage className="reject" removeMargins={props.removeMargins}>
                            <SubmitMessageIcon className="fa fa-exclamation reject" />{translation().coupon_SentRejectMessage}
                        </SubmitMessage>
                }

                {!props.isAccepted && props.errors && props.errors.length > 0 &&
                    <TicketAndCouponMessage
                        messages={props.errors.map(error => {
                            return {
                                text: error,
                                withIcon: true
                            }
                        })}
                    />
                }

                {
                    !props.hideButtons &&
                    <div className="pay-buttons">
                        {
                            props.allowTicketCopy &&
                                <TicketButton onClick={props.prepareJustSentCouponCopy} className={__IsMTSTipos__ ? "btn-primary" : "btn-secondary"}>
                                {translation().coupon_CopyTicket} {props.isTicketCopyInProgress ? <span className="fas fa-spinner fa-spin"></span> : ''}
                            </TicketButton>
                        }
                            <TicketButton className={__IsMTSTipos__ ? "btn-success" : "btn-primary"} onClick={() => { props.clearCoupon() }}>{translation().coupon_NewTicket}</TicketButton>
                    </div>
                }

            </div>
        </div>
    )

});